var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BankRemitItemView',{staticStyle:{"width":"100%","border":"1px solid var(--primaryColor)","border-top":"none","margin":"1em"},attrs:{"remitID":_vm.remitID,"canCreate":false,"checkInvoicePaid":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }